const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M8.864 4.4C9.024 4.05867 9.17867 3.76 9.328 3.504C9.488 3.248 9.64267 3.03467 9.792 2.864H0.464V2.192H9.792C9.64267 2.01067 9.488 1.792 9.328 1.536C9.17867 1.28 9.024 0.986666 8.864 0.656H9.424C10.096 1.43467 10.8 2.01067 11.536 2.384V2.672C10.8 3.03467 10.096 3.61067 9.424 4.4H8.864Z",
  fill: "#6B8FBC"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.104 18.136C17.0933 18.2533 17.0133 18.3493 16.864 18.424H7.952L7.968 18.456C7.97867 18.4773 7.99467 18.5093 8.016 18.552C8.048 18.5947 8.07467 18.6373 8.096 18.68C8.34133 19.0853 8.56 19.5013 8.752 19.928C8.96533 20.472 9.072 20.7493 9.072 20.76C9.072 20.7707 8.89067 20.776 8.528 20.776H7.984L7.92 20.6C6.992 18.232 5.48267 16.4027 3.392 15.112L3.216 15C5.424 13.6773 6.992 11.8107 7.92 9.4L7.984 9.224H8.528C8.89067 9.224 9.072 9.22933 9.072 9.24C9.072 9.25067 8.96533 9.528 8.752 10.072C8.56 10.4987 8.34133 10.9147 8.096 11.32C8.08533 11.3413 8.06933 11.368 8.048 11.4C8.03733 11.432 8.02667 11.4587 8.016 11.48C8.00533 11.4907 7.99467 11.5067 7.984 11.528C7.97333 11.5387 7.96267 11.5493 7.952 11.56V11.576H16.864C17.0133 11.6507 17.0933 11.7467 17.104 11.864C17.104 11.992 17.0187 12.1093 16.848 12.216H7.504L7.376 12.376C6.74667 13.2187 6.02133 13.9493 5.2 14.568L5.056 14.68H10.96C14.896 14.68 16.8853 14.6907 16.928 14.712C17.0453 14.776 17.104 14.8773 17.104 15.016C17.104 15.144 17.0453 15.2347 16.928 15.288C16.8853 15.3093 14.896 15.32 10.96 15.32H5.056L5.2 15.432C6.04267 16.0827 6.768 16.8133 7.376 17.624L7.504 17.784H16.848C17.0187 17.8907 17.104 18.008 17.104 18.136Z",
  fill: "#6B8FBC"
});

const SvgEquationCategory6 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationCategory6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-category-6.e6fbedb9.svg";
export { ForwardRef as ReactComponent };